export const WorkerTypes = ["USER", "CROWD", "BOT", "AI"] as const

export type APIWorkerType = typeof WorkerTypes[number]

export function getWorkerTypeDisplayText(workerType: APIWorkerType): string {
    switch (workerType) {
        case "AI":
            return "AI"
        case "USER":
            return "Human"
        case "BOT":
            return "Bot"
        case "CROWD":
            return "super.AI's in-house workers"
    }
}
